module.exports = __webpack_public_path__ + "img/barilla-placeholder220.svg?60c528bd0bd7a776410369fcf7f80c99";